import React from 'react';
import './Disclaimer.css';
// Import the background image
import bannerBackground from '../../assets/background.jpg';

const Disclaimer: React.FC = () => {
  return (
    <section id="disclaimer" className="disclaimer-section section">
      <div className="full-width-banner" style={{ backgroundImage: `url(${bannerBackground})` }}>
        <div className="banner-overlay"></div>
        <div className="banner-content">
          <h2 className="banner-title" style={{ fontFamily: "'Quicksand', sans-serif", fontWeight: 700, fontSize: '2.5rem' }}>免責聲明</h2>
        </div>
      </div>
      
      <div className="disclaimer-container">
        <div className="disclaimer-content">
          <p className="disclaimer-intro">
          學員參加 Jay Street Workout (下簡稱為 JSW ) 的課堂即表示其同意本免責聲明，請細閱本免責聲明的各項細節。
          </p>
          
          <ol className="disclaimer-list">
            <li>本人同意在課堂之前及進行時，遵守 JSW 的指引及指示。</li>
            <li>JSW 不設任何原因之退款。未能成班之課堂將會安排改期，如因惡劣天氣或其他不可抗力因素而取消的課堂同樣會作延期處理，但所有情況下均不設退款。</li>
            <li>本人明白於報讀及完成付款確認試玩課堂日子安排後，最多只能改期一次(生病除外)。如果改期後仍未能出席，則不設退款，本人需要再次支付試堂費用。</li>
            <li> 本人應自行負責攜來之財物的安全，如於活動前後或中途發生任何損傷或失竊，JSW 或任何相關教練或工作人員恕不負責。</li>
            <li>如因本人疏忽而導致活動中任何設備、器具、裝置或其他財物遭到損壞或損毀（正常損耗除外）、偷竊或被移走，本人須支付修理、修復或重新購置有關物品的費用。</li>
            <li>本人同意及容許 JSW 在課堂中拍照或錄像拍攝作記錄及宣傳用途，並且不收取任何酬勞。</li>
            <li>本人明白課程/活動牽涉體能運動。據本人所知所信，並無任何健康或其他理由導致本人不適宜參加 JSW 活動。本人健康狀況良好，並無任何既有之健康或心理問題或過敏症。</li>
            <li>本人自願參加 JSW 課程/活動，並明白部份訓練項目帶有危險性，本人知悉及明白參與 JSW 任何課程/活動會涉及受傷風險，而且程度上可能較本人日常所遇到的更大或性質有所不同。</li>
            <li>本人願意接納及承擔風險，危機及危險可能造成的人身傷害，死亡，財物損毀或損失。</li>
            <li>本人已詳細閱讀及同意上列豁免和免責條款、規則、一切條款及細則。</li>
            <li>如有任何爭議，JSW 保留最終決定權。</li>
          </ol>
        </div>
      </div>
    </section>
  );
};

export default Disclaimer;
